"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function dispatchCustomEvent(element, eventName) {
    var event = new CustomEvent(eventName);
    element.dispatchEvent(event);
}
exports.default = dispatchCustomEvent;
